(() => {
  const SELECTOR = '[data-calinfi-product-specs]';

  class CalinfiProductSpecs {
    constructor(root) {
      this.root = root;
      this.links = Array.from(root.querySelectorAll('[data-calinfi-spec-link]'));
      this.panels = Array.from(root.querySelectorAll('[data-calinfi-spec-panel]'));
      this.observer = null;
    }

    init() {
      if (this.root.dataset.calinfiProductSpecsInitialized === 'true') return;
      this.root.dataset.calinfiProductSpecsInitialized = 'true';

      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const targetId = link.getAttribute('href')?.slice(1);
          const target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.setActive(targetId);
        });
      });

      this.observePanels();
    }

    observePanels() {
      if (!('IntersectionObserver' in window) || !this.panels.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visibleEntry?.target?.id) this.setActive(visibleEntry.target.id);
        },
        {
          root: null,
          rootMargin: '-28% 0px -55% 0px',
          threshold: [0, 0.2, 0.45, 0.7],
        }
      );

      this.panels.forEach((panel) => this.observer.observe(panel));
    }

    setActive(targetId) {
      this.links.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${targetId}`;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll(SELECTOR).forEach((root) => new CalinfiProductSpecs(root).init());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
